import React from 'react';
import { useTranslation } from 'react-i18next';
import { selectColor } from '@panel/commons/core/theme';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { formatNumber } from '@panel/commons/helpers/formatAmount';
import {
  Container,
  HeaderArea,
  Icon,
  TitleText,
  TooltipComponent,
  InfoArea,
  DataWraper,
  ContainerValue,
  StyleValue,
  PercentContainer,
  DataWraperWithAnonymous,
  AnonymousText
} from './styles';

const LeadsData = ({
  icon,
  id,
  principalValue,
  secundaryValue,
  tertiaryValue,
  difference,
  differenceTotal,
  differenceTertiary,
  score,
  scoreTotal,
  scoreTertiary,
  device,
  isStatisticsByPosting,
  filter
}) => {
  const { t } = useTranslation();
  const isDesktop = device === 'desktop';
  const hasAnonymousLeads = tertiaryValue !== '0';
  const tooltipComponent = (percentId, scoreType) => {
    return (
      <TooltipComponent>
        {percentId && `${formatNumber(percentId)}% `}
        {t(`panel.estadisticas.generalData.tooltip.${percentId && scoreType === 'BAJO' ? 'downData' : 'upData'}`)}
      </TooltipComponent>
    );
  };

  return (
    <Container isDesktop={isDesktop} data-panel='panel-estadisticas-leadsData-container'>
      <HeaderArea data-panel={`panel-estadisticas-${id}-headerArea`}>
        {icon && (
          <Icon src={icon} alt={`icon-${id}`} data-panel={`panel-estadisticas-${id}-icon`} isDesktop={isDesktop} />
        )}
        {id && isDesktop && (
          <TitleText data-panel={`panel-estadisticas-${id}-title`}>
            {t(`panel.estadisticas.generalData.title.${id}`)}
          </TitleText>
        )}
      </HeaderArea>
      <InfoArea device={device} data-panel={`panel-estadisticas-${id}-infoArea`}>
        {!isDesktop && (
          <TitleText device={device} data-panel={`panel-estadisticas-${id}-title`}>
            {t(`panel.estadisticas.generalData.title.${id}`)}
          </TitleText>
        )}
        {id !== 'leads' || !hasAnonymousLeads ? (
          <>
            <DataWraper device={device}>
              <StyleValue data-panel={`panel-estadisticas-${id}-principalValue`}>
                {formatNumber(principalValue)}
              </StyleValue>
              {difference && filter !== 'customPeriod' && (
                <SimpleTooltip
                  offset={10}
                  backgroundColor={selectColor('black')}
                  isMobile={false}
                  text={tooltipComponent(difference, score)}
                  position='top-center'
                  dataPanel={`panel-estadisticas-${id}-tooltip-firstPercent`}
                  allowPlacements='top-end'
                  autoPlacements
                >
                  <PercentContainer score={score}>
                    <div className='arrow' data-panel={`panel-estadisticas-${id}-firstArrow`} />
                    <div className='valuePercent' data-panel={`panel-estadisticas-${id}-difference`}>
                      {`${formatNumber(difference)}%`}
                    </div>
                  </PercentContainer>
                </SimpleTooltip>
              )}
            </DataWraper>
            {id && (
              <p data-panel={`panel-estadisticas-${id}-infoText`}>
                {t(`panel.estadisticas.generalData.infoText.${id}${isStatisticsByPosting ? '.singular' : ''}`)}
              </p>
            )}
            <DataWraper device={device}>
              {secundaryValue && (
                <ContainerValue device={device}>
                  <StyleValue type='secondary' data-panel={`panel-estadisticas-${id}-secundaryValue`}>
                    {formatNumber(secundaryValue)}
                  </StyleValue>
                  <div className='aditional-text' data-panel={`panel-estadisticas-${id}-secundaryText`}>
                    {t('panel.estadisticas.generalData.infoText.aditional')}
                  </div>
                </ContainerValue>
              )}
              {differenceTotal && filter !== 'customPeriod' && (
                <SimpleTooltip
                  offset={10}
                  backgroundColor={selectColor('black')}
                  isMobile={false}
                  text={tooltipComponent(differenceTotal, scoreTotal)}
                  position='top-center'
                  dataPanel={`panel-estadisticas-${id}-tooltip-differenceTotal`}
                  allowPlacements='top-end'
                  autoPlacements
                >
                  <PercentContainer score={scoreTotal}>
                    <div className='arrow' data-panel={`panel-estadisticas-${id}-secondArrow`} />
                    <div className='valuePercent' data-panel={`panel-estadisticas-${id}-differenceTotal`}>
                      {`${formatNumber(differenceTotal)}%`}
                    </div>
                  </PercentContainer>
                </SimpleTooltip>
              )}
            </DataWraper>
          </>
        ) : (
          <DataWraperWithAnonymous>
            <DataWraper device={device}>
              <ContainerValue device={device}>
                <StyleValue data-panel={`panel-estadisticas-${id}-principalValue`}>
                  {formatNumber(principalValue)}
                </StyleValue>
                {device === 'desktop' && (
                  <AnonymousText device={device} withMarginLeft data-panel={`panel-estadisticas-${id}-principalText`}>
                    {hasAnonymousLeads
                      ? t('panel.estadisticas.generalData.infoText.leads.hasAnonymousLeads')
                      : t('panel.estadisticas.generalData.infoText.leads')}
                  </AnonymousText>
                )}
              </ContainerValue>
              {difference && filter !== 'customPeriod' && (
                <SimpleTooltip
                  offset={10}
                  backgroundColor={selectColor('black')}
                  isMobile={false}
                  text={tooltipComponent(difference, score)}
                  position='top-center'
                  dataPanel={`panel-estadisticas-${id}-tooltip-firstPercent`}
                  allowPlacements='top-end'
                  autoPlacements
                >
                  <PercentContainer score={score}>
                    <div className='arrow' data-panel={`panel-estadisticas-${id}-firstArrow`} />
                    <div className='valuePercent' data-panel={`panel-estadisticas-${id}-difference`}>
                      {`${formatNumber(difference)}%`}
                    </div>
                  </PercentContainer>
                </SimpleTooltip>
              )}
            </DataWraper>
            {device !== 'desktop' && (
              <AnonymousText device={device} data-panel={`panel-estadisticas-${id}-principalText`}>
                {t('panel.estadisticas.generalData.infoText.leads')}
              </AnonymousText>
            )}
            <DataWraper device={device}>
              <ContainerValue device={device}>
                <StyleValue data-panel={`panel-estadisticas-${id}-secondaryValue`}>
                  {formatNumber(tertiaryValue)}
                </StyleValue>
                {device === 'desktop' && (
                  <AnonymousText device={device} withMarginLeft data-panel={`panel-estadisticas-${id}-secondaryText`}>
                    {t('panel.estadisticas.generalData.infoText.leads.anonymous')}
                  </AnonymousText>
                )}
              </ContainerValue>
              {differenceTertiary && filter !== 'customPeriod' && (
                <SimpleTooltip
                  offset={10}
                  backgroundColor={selectColor('black')}
                  isMobile={false}
                  text={tooltipComponent(differenceTertiary, scoreTertiary)}
                  position='top-center'
                  dataPanel={`panel-estadisticas-${id}-tooltip-secondaryPercent`}
                  allowPlacements='top-end'
                  autoPlacements
                >
                  {differenceTertiary !== '0' && (
                    <PercentContainer score={scoreTertiary}>
                      <div className='arrow' data-panel={`panel-estadisticas-${id}-secondaryArrow`} />
                      <div className='valuePercent' data-panel={`panel-estadisticas-${id}-secondaryDifference`}>
                        {`${formatNumber(differenceTertiary)}%`}
                      </div>
                    </PercentContainer>
                  )}
                </SimpleTooltip>
              )}
            </DataWraper>
            {device !== 'desktop' && (
              <AnonymousText device={device} data-panel={`panel-estadisticas-${id}-secondaryText`}>
                {t('panel.estadisticas.generalData.infoText.leads.anonymous')}
              </AnonymousText>
            )}
            <DataWraper device={device} withSeparator>
              {secundaryValue && (
                <ContainerValue device={device} withAnonymous>
                  <StyleValue type='secondary' withAnonymous data-panel={`panel-estadisticas-${id}-tertiaryValue`}>
                    {formatNumber(secundaryValue)}
                  </StyleValue>
                  <div className='aditional-text' data-panel={`panel-estadisticas-${id}-tertiaryText`}>
                    {t('panel.estadisticas.generalData.infoText.aditional')}
                  </div>
                </ContainerValue>
              )}
              {differenceTotal && filter !== 'customPeriod' && (
                <SimpleTooltip
                  offset={10}
                  backgroundColor={selectColor('black')}
                  isMobile={false}
                  text={tooltipComponent(differenceTotal, scoreTotal)}
                  position='top-center'
                  dataPanel={`panel-estadisticas-${id}-tooltip-tertiaryPercent`}
                  allowPlacements='top-end'
                  autoPlacements
                >
                  <PercentContainer score={scoreTotal}>
                    <div className='arrow' data-panel={`panel-estadisticas-${id}-tertiaryArrow`} />
                    <div className='valuePercent' data-panel={`panel-estadisticas-${id}-tertiaryDifferenceTotal`}>
                      {`${formatNumber(differenceTotal)}%`}
                    </div>
                  </PercentContainer>
                </SimpleTooltip>
              )}
            </DataWraper>
          </DataWraperWithAnonymous>
        )}
      </InfoArea>
    </Container>
  );
};

export default LeadsData;
